export class CategoryConstants {
	public static readonly NonUsEmergingMarketCategories = ['asiaEmerging', 'europeEmerging', 'latinAmerica', 'africaAndMiddleEast'];

	public static readonly defaultMunicipalBondMorningstarCategoryList = [
		'Muni California Intermediate',
		'Muni California Long',
		'Muni Massachusetts',
		'Muni Minnesota',
		'Muni National Interm',
		'Muni National Long',
		'Muni National Short',
		'Muni New Jersey',
		'Muni New York Intermediate',
		'Muni New York Long',
		'Muni Ohio',
		'Muni Pennsylvania',
		'Muni Single State Interm',
		'Muni Single State Long',
		'Muni Single State Short',
		'Muni Target Maturity',
		'High Yield Muni'
	];

	public static readonly defaultDerivativesOrOptionsMorningstarCategoryList = ['Derivative Income', 'Options Trading', 'Options-based'];
}
